/**
 * Create a Facebook share link.
 * Replace the string "(HOST)"" with the current host in the share links
 */
function $createFacebookShareLink(url) {
	$('.detailpost__link--facebook').attr('href', function(i, val) {
		return val.replace('(HOST)', window.location.origin);
	});
}

export default $createFacebookShareLink;



// WEBPACK FOOTER //
// ./src/js/app/components/facebook-share.js